const dict: Record<string, string> = {
  // Nav
  dashboard: "Panel",
  catalog: "Catálogo",
  cart: "Carrito",
  orders: "Pedidos",
  account: "Cuenta",
  invoices: "Facturas",
  nav_main: "Trabajo",
  nav_account: "Cuenta",

  // Common
  search: "Buscar",
  search_products: "Buscar por SKU, nombre...",
  filter: "Filtro",
  sort: "Ordenar",
  add_to_cart: "Añadir",
  in_cart: "En carrito",
  place_order: "Realizar pedido",
  add_short: "Añadir",
  add_more: "Añadir más",
  total: "Total",
  subtotal: "Subtotal",
  discount: "Descuento",
  delivery: "Envío",
  qty: "Cant.",
  qty_decrement: "Disminuir cantidad",
  qty_increment: "Aumentar cantidad",
  logist_addr_derybasivska: "Derybasivska 12",
  logist_addr_tairova: "Tairova · Glushka 32",
  logist_addr_sklad: "Almacén · Promyslova 4",
  unit: "Por unidad",
  price: "Precio",
  retail: "Minorista",
  your_price: "Tu precio",
  saved: "Ahorras",
  sku: "SKU",
  stock: "Stock",
  in_stock: "Disponible",
  low_stock: "Poco",
  out_of_stock: "Agotado",
  create_order: "Crear pedido",
  repeat_order: "Repetir pedido",
  view_all: "Ver todos",
  items: "Artículos",
  items_word: "artículos",
  amount: "Importe",
  product: "Producto",
  status: "Estado",
  payment: "Pago",
  paid: "Pagado",
  unpaid: "No pagado",
  free: "Gratis",
  optional: "opcional",
  clear: "Limpiar",
  retry: "Reintentar",
  repeat: "Repetir",
  invoice: "Factura",
  order: "Pedido",
  date: "Fecha",
  due: "Vencimiento",
  due_by: "antes",
  primary: "Principal",
  primary_m: "Principal",
  yes: "Sí",
  no: "No",
  all: "Todos",
  view: "Vista",
  admin: "Admin",
  user: "Usuario",
  invite: "Invitar",
  added: "Añadido:",
  category: "Categoría",

  // Status
  status_new: "Nuevo",
  status_processing: "En proceso",
  status_shipped: "Enviado",
  status_delivered: "Entregado",
  status_cancelled: "Cancelado",

  // Login
  login_title: "Acceso al portal B2B",
  login_sub: "Gestiona pedidos al por mayor para tu negocio.",
  email: "Email",
  password: "Contraseña",
  show_password: "Mostrar contraseña",
  hide_password: "Ocultar contraseña",
  forgot: "¿Olvidaste tu contraseña?",
  sign_in: "Iniciar sesión",
  or: "o",
  magic: "Enviar enlace de acceso",
  magic_link_send: "Enviar enlace mágico",
  magic_check_email: "Revisa tu correo",
  no_account: "¿Aún no tienes acceso?",
  request: "Solicitar cuenta",
  wholesale_portal: "Portal mayorista",
  signing_in: "Iniciando sesión...",
  invalid_email: "Email no válido",
  r_required_field: "Complete los campos obligatorios",
  r_submit_error: "No se pudo enviar la solicitud. Inténtelo de nuevo.",
  check_inbox: "Revisa tu bandeja",
  magic_sent: "Hemos enviado un enlace de acceso a",
  magic_expire: "El enlace expira en 15 minutos.",
  back_to_password: "Volver a contraseña",
  brand_panel_copy:
    "Pide granos, equipamiento y accesorios directamente del tostadero con precios negociados, NET-14 y un gestor dedicado.",
  partner_venues: "locales asociados",
  on_market: "en el mercado",
  payment_terms_label: "condiciones de pago",

  // Dashboard
  welcome: "Bienvenido de nuevo",
  your_tier: "Tu plan",
  personal_manager: "Gestor personal",
  balance: "Saldo",
  recent_orders: "Pedidos recientes",
  quick_actions: "Acciones rápidas",
  today_date_long: "18 DE ABRIL DE 2026 · SÁBADO",
  dash_sub_a: "Tu saldo, pedidos y acciones rápidas para ",
  dash_sub_b: ".",
  credit: "Crédito",
  tier_b_hint: "Precios personalizados — 20% off del minorista",
  saved_this_year: "Ahorrado este año",
  across_word: "en",
  orders_word: "pedidos",
  active_orders: "Pedidos activos",
  one_processing: "1 en proceso",
  send_message: "Enviar mensaje",
  whats_new: "Novedades",
  frequent_items: "Tus artículos frecuentes",
  one_click_reorder: "Repetir con un clic",

  // Catalog
  categories: "Categorías",
  availability: "Disponibilidad",
  origin: "Origen",
  weight: "Peso",
  cat_beans: "Grano",
  cat_ground: "Molido / drip",
  cat_equipment: "Equipamiento",
  cat_accessories: "Accesorios",
  cat_training: "Formación",
  view_grid: "Cuadrícula",
  view_table: "Tabla",
  wholesale_catalog: "Catálogo mayorista",
  catalog_sub_a: " SKUs · Precios según tu acuerdo HoReCa Tier B",
  any_availability: "Cualquier disponibilidad",
  featured: "Destacados",
  price_low_high: "Precio: menor → mayor",
  price_high_low: "Precio: mayor → menor",
  alpha: "A → Z",
  all_items: "Todos los productos",
  catalog_err: "No se pudo cargar el catálogo",
  catalog_err_sub: "Comprueba tu conexión y vuelve a intentar.",
  nothing_found: "Nada encontrado",
  nothing_found_sub: "Prueba otras palabras clave o limpia los filtros.",
  clear_filters: "Limpiar filtros",
  restocking: "Reponiendo",

  // Cart
  your_cart: "Tu carrito",
  empty_cart: "Carrito vacío",
  empty_cart_sub: "Añade productos del catálogo para iniciar un pedido.",
  go_to_catalog: "Ir al catálogo",
  order_summary: "Resumen del pedido",
  delivery_address: "Dirección de envío",
  payment_method: "Método de pago",
  payment_terms: "Pago NET-14",
  delivery_method: "Método de envío",
  choose_one: "Elige una opción",
  odesa_logist: "Logística propia · Odesa",
  odesa_logist_meta: "1–2 días laborables · en la ciudad",
  odesa_logist_short: "Logística Odesa",
  np_short: "Nova Poshta",
  min_prefix: "mín.",
  available_from: "Disponible desde",
  shortfall_a: "Añade ",
  shortfall_b: " más para acceder, o elige Nova Poshta abajo.",
  add_items: "Añadir productos",
  switch_to_np: "Cambiar a Nova Poshta",
  np_switched_toast:
    "Envío cambiado a Nova Poshta: subtotal inferior a 2 000 ₴",
  np_branch: "Nova Poshta · sucursal",
  np_meta: "1–3 días laborables · nacional",
  city: "Ciudad",
  branch_num: "Nº de sucursal",
  order_note: "Comentario del pedido",
  order_note_ph: "Notas de envío, etiquetado, etc...",
  delivery_via_odesa: "Envío · Logística Odesa",
  delivery_via_np: "Envío · Nova Poshta",
  incl_vat: "Incl. IVA 20% ·",
  payment_status_unpaid: "Estado de pago: No pagado",
  payment_status_unpaid_sub:
    "Pedido creado sin pago inmediato. Tu gestor enviará la factura.",
  net14_note: "Sin pago inmediato · NET-14",
  order_copied: "Pedido copiado al carrito",
  order_created_a: "Pedido creado ·",
  order_created_b: "· No pagado",
  order_error: "No se pudo crear el pedido. Inténtalo de nuevo.",

  // Orders
  order_history: "Historial de pedidos",
  order_num: "Nº de pedido",
  ordered_on: "Fecha",
  orders_total_suffix: " pedidos en total · Haz clic para ver detalles",
  search_by_num: "Buscar por número...",
  no_orders: "Aún no hay pedidos",
  fulfilment: "Envío",
  line_items: "Líneas del pedido",
  unpaid_awaiting: "No pagado · esperando factura",
  payment_colon: "Pago:",
  download_invoice: "Descargar factura",
  invoice_sent: "Factura enviada a tu correo",

  // Account
  company: "Empresa",
  addresses: "Direcciones",
  payment_methods: "Pago",
  account_settings: "Cuenta y ajustes",
  account_sub: "Gestiona tu empresa, direcciones de envío y métodos de pago.",
  team: "Equipo",
  preferences: "Preferencias",
  company_details: "Datos de la empresa",
  save_changes: "Guardar cambios",
  legal_name: "Razón social",
  brand_name: "Nombre comercial",
  tax_id: "CIF",
  vat_registered: "Sujeto a IVA",
  billing_email: "Email de facturación",
  phone: "Teléfono",
  your_manager: "Tu gestor",
  payment_terms_row: "Condiciones de pago",
  customer_since: "Cliente desde",
  upgrade_tier: "Sube a Tier A desde 500 000 UAH/año — faltan 84 000 UAH.",
  credit_line: "Línea de crédito",
  available_word: "disponible",
  used: "Usado",
  limit: "Límite",
  delivery_addresses: "Direcciones de envío",
  add_address: "Añadir dirección",
  payment_methods_title: "Métodos de pago",
  add_method: "Añadir método",
  net14_apply:
    "Las condiciones NET-14 se aplican automáticamente a pedidos superiores a 5 000 UAH.",
  owner_role: "Propietario",
  procurement: "Compras",
  head_barista: "Barista principal",
  team_members: "Miembros del equipo",
  team_role: "Permisos",
  role_orders: "Pedidos",
  notifications: "Notificaciones",
  help: "Ayuda",
  menu: "Menú",
  search_placeholder: "Buscar todo...",
  close: "Cerrar",
  guest: "Invitado",
  logout: "Cerrar sesión",
  remove: "Eliminar",
  notif_status: "Actualizaciones de estado del pedido",
  notif_restock: "Alertas de reposición",
  notif_new_arrivals: "Novedades del catálogo",
  notif_promo: "Promociones de temporada",

  // Invoices
  invoices_title: "Facturas y documentos",
  invoices_sub: "Facturas fiscales, albaranes y recibos.",
  export_csv: "Exportar CSV",

  // Not found
  not_found_title: "Página no encontrada",
  not_found_subtitle:
    "El enlace puede estar desactualizado o la página se movió.",
  go_to_dashboard: "Ir al panel",

  // Misc
  today: "hoy",
  yesterday: "ayer",
  days_ago: "d atrás",

  // Register
  r_eyebrow: "Portal mayorista · Solicitud",
  r_title: "Solicitar una cuenta",
  r_sub:
    "Cuéntanos sobre tu negocio — tu gestor preparará una propuesta personalizada en 1 día laboral.",
  r_s1: "Empresa",
  r_s2: "Local",
  r_s3: "Contacto",
  r_step: "Paso",
  r_of: "de",
  r_company_legal: "Razón social",
  r_company_hint: "S.L. / autónomo",
  r_edrpou: "CIF",
  r_vat: "Sujeto a IVA",
  r_yes: "Sí",
  r_no: "No",
  r_brand_name: "Nombre del local (marca)",
  r_brand_hint: "Nombre público que ven los clientes",
  r_venue_type: "Tipo de local",
  r_cafe: "Cafetería",
  r_restaurant: "Restaurante",
  r_hotel: "Hotel",
  r_office: "Oficina / corporativo",
  r_reseller: "Revendedor",
  r_other: "Otro",
  r_venues: "Número de locales",
  r_volume: "Consumo mensual estimado de café",
  r_v1: "Hasta 20 kg",
  r_v2: "20–50 kg",
  r_v3: "50–150 kg",
  r_v4: "Más de 150 kg",
  r_name_full: "Nombre completo del contacto",
  r_role: "Tu rol",
  r_owner: "Propietario",
  r_buyer: "Comprador",
  r_barista: "Barista principal",
  r_manager: "Gerente",
  r_email: "Email de trabajo",
  r_phone: "Teléfono",
  r_note: "Nota para el gestor",
  r_note_ph: "Qué estás comprando, marcas favoritas, necesidades especiales...",
  r_accept_tos: "Acepto los términos de cooperación y el tratamiento de datos",
  r_accept_tos_required: "Debes aceptar los términos",
  r_continue: "Continuar",
  r_back: "Atrás",
  r_submit: "Enviar solicitud",
  r_have_account: "¿Ya tienes acceso?",
  r_sign_in: "Iniciar sesión",
  r_sent_title: "¡Solicitud recibida!",
  r_sent_sub:
    "Anna Lytvyn, tu futura gestora, te contactará en menos de 24 horas en el número",
  r_what_next: "Qué pasa ahora",
  r_n1: "Tu gestor verificará los datos y fijará precios HoReCa personalizados",
  r_n2: "Recibirás un email con login y contraseña temporal",
  r_n3: "Primer pedido — con descuento de −5% en todo el carrito",
  r_back_to_site: "Volver a foundation.ua",
  r_why_title: "Por qué unirte a Foundation B2B",
  r_w1_t: "Precios personalizados",
  r_w1_s: "Tarifas HoReCa de −15% a −25% del minorista",
  r_w2_t: "Pago NET-14",
  r_w2_s: "Facturación diferida para socios establecidos",
  r_w3_t: "Gestor personal",
  r_w3_s: "Línea directa, sin cola de tickets",
  r_w4_t: "Entrega prioritaria",
  r_w4_s: "Siguiente día en Odesa, 2 días a nivel nacional",
  r_for_venues: "Para locales y revendedores",
  r_hero_a: "Conviértete en",
  r_hero_b: "socio",
  r_hero_c: "Foundation.",
  r_bottom_copy:
    "Más de 240 locales en Ucrania compran granos, equipamiento y accesorios directamente de nuestro tostadero en Odesa.",
};

export default dict;
